module.exports = __webpack_public_path__ + "media/images/icons/sound-cf5deb0388db39a7d4e143c0914f30a4.svg";